import { render, staticRenderFns } from "./LabelTooltip.vue?vue&type=template&id=937e9896&"
import script from "./LabelTooltip.vue?vue&type=script&lang=ts&"
export * from "./LabelTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports